import { TenantModel } from '@core/services/api.service';

export class LoadTenantsAction {
  static readonly type = '[Tenants] Load Tenants';
}

export class LoadTenantsSuccessAction {
  static readonly type = '[Tenants] Load Tenants Success';

  constructor(public payload: { tenants: TenantModel[] }) { }
}

export class LoadTenantsFailAction {
  static readonly type = '[Tenants] Load Tenants Fail';
}
